import { ActionTypes } from './index';

type TAnyObject = Record<string, unknown>;

export const showPopup = (popupId: string, data?: TAnyObject) => ({
    type: ActionTypes.SHOW_POPUP,
    payload: {
        popupId,
        data: data,
    },
});

export const hidePopup = (popupId: string) => ({
    type: ActionTypes.HIDE_POPUP,
    payload: {
        popupId,
    },
});

export const resetPopup = () => ({
    type: ActionTypes.RESET_POPUP,
    payload: {},
});

export const setPopupData = (popupId: string, data: TAnyObject) => ({
    type: ActionTypes.SET_POPUP_DATA,
    payload: {
        popupId,
        data,
    },
});
